import { render, staticRenderFns } from "./CreateTurnList.vue?vue&type=template&id=b28e4730"
import script from "./CreateTurnList.vue?vue&type=script&lang=js"
export * from "./CreateTurnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports